function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { debugLog } from '../../debugLog';
import { getUseSkywayAudioGainToggle } from '../../logics/dataOps';
export class CHELCarnelianAgoraPlayer {
    setData(data) {
        debugLog('[ setData ] CHELCarnelianAgoraPlayer: Method not implemented.');
    }
    getName() {
        debugLog('[ getName ] CHELCarnelianAgoraPlayer: Method not implemented.');
        return '';
    }
    getParam(key) {
        debugLog('[ getParam ] CHELCarnelianAgoraPlayer: Method not implemented.');
        return '';
    }
    SetScreenShare(use) {
        debugLog('[ SetScreenShare ] CHELCarnelianAgoraPlayer: Method not implemented.');
    }
    IsScreenShare() {
        debugLog('[ IsScreenShare ] CHELCarnelianAgoraPlayer: Method not implemented.');
        return false;
    }
    release() {
        debugLog('[ release ] CHELCarnelianAgoraPlayer: Method not implemented.');
    }
    getPeerId() {
        return this.playerId;
    }
    getPlayerId() {
        return this.playerId;
    }
    setStream(stream) {}
    setChannelSessionCode(channelSessionCode) {
        this.channelSessionCode = channelSessionCode;
    }
    getChannelSessionCode() {
        return this.channelSessionCode;
    }
    getValue(key) {
        // @ts-ignore
        return this[key];
    }
    getVideoMediaStream() {
        return this.videoMediaStream;
    }
    setVideoMediaStream(stream) {
        this.videoMediaStream = stream;
    }
    setAgoraUser(agoraUser) {
        this.agoraUser = agoraUser;
    }
    getVideoItemName() {
        return this.videoItemName;
    }
    setVideoItemName(itemName) {
        this.videoItemName = itemName;
    }
    getVideoMaterialName() {
        return this.videoMaterialName;
    }
    setVideoMaterialName(materialName) {
        this.videoMaterialName = materialName;
    }
    setVolume(volume) {
        this.volume = volume;
        this.updateVolume();
    }
    SetVoiceAttenuate(volume) {
        this.attenuateVolume = volume;
        this.updateVolume();
    }
    SetMute(mute) {
        this.mute = mute;
        this.updateVolume();
    }
    updateVolume() {
        // 距離減衰有効無効
        const useSkywayAudioGainToggle = getUseSkywayAudioGainToggle();
        if (!useSkywayAudioGainToggle) {
            return;
        }
        if (this.agoraUser && this.agoraUser.hasAudio && this.agoraUser.audioTrack) {
            const fixedVolume = this.volume * this.attenuateVolume * (this.mute ? 0.0 : 1.0);
            /*
      console.log(
        'Player updateVolume',
        this.getPlayerId(),
        fixedVolume,
        this.volume,
        this.attenuateVolume
      );
      */ this.agoraUser.audioTrack.setVolume(100.0 * fixedVolume);
        }
    /*

    if (worldViewerWindow.hel_isiPhone()) {
      if (this.gainNode !== undefined) {
        this.gainNode.gain.value = this.volume * this.attenuateVolume * (this.mute ? 0.0 : 1.0);
      }
    } else {
      this.audio.volume = this.volume * this.attenuateVolume * (this.mute ? 0 : 1);
    }
    */ }
    setFullAvatarState(isFullAvatar) {
        this.isFullAvatar = isFullAvatar;
    }
    setMotionTrackingState(isMotionTracking) {
        this.isMotionTracking = isMotionTracking;
    }
    isHighFrequentSync() {
        if (this.role === 'presenter') {
            return true;
        }
        if (this.isFullAvatar && this.isMotionTracking) {
            return true;
        }
        return false;
    }
    constructor(playerId, userCode, volume, role, rtcUserCode){
        _defineProperty(this, "playerId", void 0);
        _defineProperty(this, "context", void 0);
        _defineProperty(this, "gainNode", void 0);
        _defineProperty(this, "volume", void 0);
        _defineProperty(this, "attenuateVolume", void 0);
        _defineProperty(this, "mute", void 0);
        _defineProperty(this, "source", void 0);
        _defineProperty(this, "audioDestination", void 0);
        _defineProperty(this, "audio", void 0);
        _defineProperty(this, "role", void 0);
        _defineProperty(this, "rtcUserCode", void 0);
        _defineProperty(this, "agoraUser", void 0);
        _defineProperty(this, "channelSessionCode", void 0);
        _defineProperty(this, "videoMediaStream", void 0);
        _defineProperty(this, "videoItemName", void 0);
        _defineProperty(this, "videoMaterialName", void 0);
        _defineProperty(this, "isFullAvatar", void 0);
        _defineProperty(this, "isMotionTracking", void 0);
        // console.log(playerId, userCode, volume, role);
        this.playerId = playerId;
        this.role = role;
        this.audio = document.createElement('audio');
        this.volume = volume;
        this.attenuateVolume = 0.0;
        this.mute = false;
        this.channelSessionCode = '';
        this.rtcUserCode = rtcUserCode;
        this.updateVolume();
        this.videoMediaStream = new MediaStream();
        this.videoItemName = '';
        this.videoMaterialName = '';
        this.isFullAvatar = true;
        this.isMotionTracking = false;
    }
}
